export enum NotecardEditorContentType {
    front = 'Front',
    back = 'Back',
    metadata = 'Metadata',
    commentThread = 'Comment Thread',
    convertToPracticeProblem = 'Practice Problem Counterpart',
}

export interface NotecardEditorProps {
    notecardID: string
}
